class MixCollect extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup();
    }
    setup() {
        const waveAnim = () => {
            const countWave = 5;
            const waveArr = this.querySelector(".mix-collect-item-img-deco-item");
            if (waveArr) {

                const innerContainer = this.querySelector(".mix-collect-item-img-deco-inner");
                if (innerContainer) {
                    innerContainer.innerHTML = "";
                    for (let i = 0; i < countWave; i++) {
                        const html = waveArr.cloneNode(true); // Clone the element
                        html.style.animationDelay = `${(-15 / countWave) * i}s`;
                        innerContainer.appendChild(html);
                    }
                }
            }
        };
        waveAnim();
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.mix-collect-text') },
            tweenArr: [
                new RevealText({ el: this.querySelector('.mix-collect-title .txt'), color: 'black' }),
            ]
        });
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.mix-collect-sub') },
            tweenArr: [
                new FadeSplitText({ el: this.querySelector('.mix-collect-sub .txt') }),
                new FadeSplitText({ el: this.querySelector('.mix-collect-desc .txt'), delay: "<=0.25" }),
            ]
        });
        if (!getScreenType().isMobile) {
            gsap.set('.mix-collect-item:not(.full)', { autoAlpha: 0 });
        }
        ScrollTrigger.batch('.mix-collect-item:not(.full)', {
            start: 'top 60%',
            batchMax: 2,
            once: true,
            onEnter: batch => {
                batch.forEach((el, index) => {
                    if (!getScreenType().isMobile) {
                        gsap.set(el, { autoAlpha: 1 });
                    }
                    new MasterTimeline({
                        triggerInit: this,
                        timeline: gsap.timeline({ delay: index * .1 }),
                        tweenArr: [
                            new FadeIn({ el: el.querySelector(".mix-collect-item-img-bg"), clearProps: 'opacity' }),
                            new ScaleInset({ el: el.querySelector(".mix-collect-item-img") }),
                            new FadeSplitText({ el: el.querySelector(".mix-collect-item-info .mix-collect-item-title .txt") }),
                            new FadeIn({ el: el.querySelector(".mix-collect-item-info .mix-collect-item-price"), delay: "<=.1" }),
                            ...Array.from(el.querySelector('.mix-collect-item-desc .txt p').querySelectorAll('span')).map((el) => new FadeSplitText({ el, delay: "<=.1" })),
                            new FadeIn({ el: el.querySelector(".mix-collect-item-more"), delay: "<=.3" }),
                            new FadeIn({ el: el.querySelector(".mix-collect-item-form-quantity") }),
                            new FadeIn({
                                el: el.querySelector(".mix-collect-item-form-submit"),
                                delay: "<=.1"
                            }),
                            new FadeIn({
                                el: el.querySelector(".mix-collect-item-detail .txt"),
                                delay: "<=.1"
                            }),
                        ],
                    });
                })
            }
        })
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.mix-collect-item.full .mix-collect-item-img') },
            tweenArr: [
                new FadeIn({ el: this.querySelector('.mix-collect-item.full .mix-collect-item-img') }),
                new FadeIn({ el: this.querySelector('.mix-collect-item.full .mix-collect-item-img-inner'), delay: '<=.15', onComplete: () => {
                    this.querySelectorAll('.mix-collect-item.full .mix-collect-item-img-deco-item').forEach(item => {
                        item.classList.add('anim');
                    })
                    gsap.to(this.querySelector('.mix-collect-item.full .mix-collect-item-img-deco-inner'), { opacity: 1, duration: .6, ease: 'none' })
                } }),
            ]
        });
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.mix-collect-item.full .mix-collect-item-info') },
            tweenArr: [
                new FadeSplitText({ el: this.querySelector(".mix-collect-item.full .mix-collect-item-title .txt") }),
                new FadeIn({ el: this.querySelector(".mix-collect-item.full .mix-collect-item-price"), delay: "<=.1" }),
                ...Array.from(this.querySelector('.mix-collect-item.full .mix-collect-item-desc .txt').querySelectorAll('span')).map((el) => new FadeSplitText({ el })),
                new FadeIn({ el: this.querySelector(".mix-collect-item.full .mix-collect-item-more"), delay: "<=.2" }),
                new FadeIn({ el: this.querySelector(".mix-collect-item.full .mix-collect-item-form-quantity"), delay: '<=.1' }),
                new FadeIn({ el: this.querySelector(".mix-collect-item.full .mix-collect-item-form-submit") }),
                new FadeIn({
                    el: this.querySelector(".mix-collect-item.full .mix-collect-item-detail .txt"),
                    delay: "<=.1"
                }),
            ]
        });

        if (getScreenType().isDesktop) {
            gsap.set(this.querySelector('.mix-collect-text-inner'), { top: (window.innerHeight - this.querySelector('.mix-collect-text-inner').offsetHeight) / 2 })
        }
    }
}

customElements.define('mix-collect', MixCollect);